import React, {useEffect, useState} from "react";
import { Layout, Breadcrumb, Divider } from "antd";
import { useNavigate } from "react-router-dom";
import { Drivers } from "../../Components";
import { useDispatch } from "react-redux";
import { utils } from "../../Utils";
import { message } from 'antd';

const DriverScreen = ({pcount, initialData, loaded}) =>
{
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [email, setEmail] = useState('');
	const [storeId, setStoreId] = useState('');
	const [level, setLevel] = useState('');
	const [users, setDrivers] = useState(initialData);
	const { Content } = Layout;

	const breadcrumbItems = [
		{ breadcrumbName: "Drivers", title: "Drivers" },
		{ breadcrumbName: "All Drivers", title: "All Drivers" },
	];

	useEffect(() =>
	{
		const email = localStorage.getItem("aduseremail");
		const storeId = localStorage.getItem("aduserstoreId");
		setEmail(email ?? '');
		setStoreId(storeId ?? '');
		// eslint-disable-next-line
	}, []);


	useEffect(() => {
		window.document.body.style.overflow = "auto";
		document.title = "Drivers List | ErrandLocal";
	}, []);

	useEffect(() => {
		//console.log('PPo', loaded, localStorage.getItem('aduserstoreId'));
	  if (loaded && localStorage.getItem('aduserstoreId')) {
			const interval = setInterval(async() => {
				if (!localStorage.getItem('adloguser')) return;
			    const role = utils.checkUser('role');
			    if (role === 'Level2') {
					setLevel(role);
					await fetchDrivers();
				}else{
					setLevel('');
				}
			}, 60000);
			return () => clearInterval(interval);
	  }
	}, [loaded]);

	const fetchDrivers = async () =>
	{
		try{
			if(!localStorage.getItem('aduseremail')){
				return;
			}
			const email = localStorage.getItem('aduseremail');
			const header = await utils.genHeader();
			const target = await utils.ADMIN_DRIVERS;
			const data = await utils.fetchURL(target, 'GET', '', header);
			const usersFromServer = await data.json();
			if(usersFromServer?.data.length > 0 && usersFromServer?.data !== users){
				setDrivers(usersFromServer?.data);
			}
		}catch(e){}
	}

	const onPostAction = async (param) =>
	{
		try{
			//const header = await utils.genHeader();
			const token = utils.checkUser('token');
			if(!token){
				message.error('Invalid token');
				return false;
			}
			const target = utils.PROCESS_STORE;
			const res = await utils.fetchURL(target, 'POST', JSON.stringify(param), {'Authorization': token});

			const data = await res.json();
			if(data.msg === 'Token Updated'){
				//utils.updateUserData({token: data?.token});
				message.info('Please resubmit');
				return;
			}
			if(data.msg === 'Success' || data.msg === 'Successful'){
				message.success('Operation was successful');
			}else{
				message.error(data.msg);
			}
		}catch(e){
			message.error(e.message);
		}
	}


	return (
		<Content style={{ margin: "24px 16px 0", fontFamily: "Lato" }}>
		  <div
			style={{
			  marginBottom: 16,
			  display: "flex",
			  flexDirection: "row",
			  justifyContent: "space-between",
			}}
		  >
			<Breadcrumb items={breadcrumbItems} />
		  </div>
		  <div
			className="site-layout-background"
			style={{
			  padding: 24,
			  minHeight: 360,
			  backgroundColor: "#f7faf6",
			}}
		  >
			<h2 style={{ color: "#001529" }}>All Drivers</h2>
			<span style={{ opacity: 0.5 }}>List of all registered drivers</span>
			<Divider />
			{users.length > 0 && (<Drivers pcount={pcount} users={users} onPostAction={onPostAction} />)}
		  </div>
		</Content>
	);


};

export default DriverScreen;
